export default "__VITE_ASSET__KZyjVGQV__"